import React, { useEffect, useState } from "react";
import Button from "../../../Components/Common/Button";
import YoutubeVideoModal from "../../../Components/Common/YoutubeVideoModal";

const HomeVideos = ({ data }) => {
  const content = data?.data?.content;
  const [videoData, setVideoData] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    if (content) {
      const cont = JSON.parse(content);

      if (cont) {
        setVideoData([
          {
            title: cont?.video1Title || "",
            subtitle: cont?.video1Subtitle || "",
            link: cont?.video1Link || "",
          },
          {
            title: cont?.video2Title || "",
            subtitle: cont?.video2Subtitle || "",
            link: cont?.video2Link || "",
          },
          {
            title: cont?.video3Title || "",
            subtitle: cont?.video3Subtitle || "",
            link: cont?.video3Link || "",
          },
        ]);
      }
    }
  }, [content]);

  return (
    <div className="pt-24">
      <h2 className="text-3xl font-bold text-center text-[#2a4258] mb-12">
        See Our Videos
      </h2>

      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-4">
        {videoData.map((video, index) => {
          const videoIdMatch = video.link.match(/(?:youtu\.be\/|v=)([^&?/]+)/);
          const videoId = videoIdMatch ? videoIdMatch[1] : "";
          const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

          return (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden flex flex-col"
            >
              {/* Thumbnail */}
              <img
                src={thumbnailUrl}
                alt="Video Thumbnail"
                className="w-full h-48 object-cover"
              />

              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-xl font-semibold text-[#2a4258] mb-2">
                  {video.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4">{video.subtitle}</p>
                <Button
                  onClick={() => setSelectedVideo(video.link)}
                  className="mt-auto px-4 py-2 bg-[#2a4258] text-white rounded-full text-sm font-medium transition hover:bg-[#1e3246]"
                >
                  See Video
                </Button>
              </div>
            </div>
          );
        })}
      </div>
      <YoutubeVideoModal
        videoSrc={selectedVideo}
        isOpen={selectedVideo !== null}
        onCancel={() => {
          setSelectedVideo(null);
        }}
        // isLoading={videoLoading}
      />
    </div>
  );
};

export default HomeVideos;
